import { i18n } from "services/i18nService";

import { initialErrorState } from "views/common";

export function isValid(record) {
  const { objectType } = record;

  const errors = initialErrorState();
  errors.entity = [];

  if (!objectType) {
    errors.messages.push(i18n("isValid.import.objectType"));
    errors.entity.push("objectType");
  }

  return errors;
}
